import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { WorkingHours } from "./WorkingHours";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { OrgOfferings } from "./OrgOfferings";
import { Appointments } from "./Appointments";
import { LeftNav } from "../components/navigation/LeftNav";
import styled from "@emotion/styled";
import { Outlet, useNavigate } from "react-router-dom";
import { MainHeader } from "src/components/navigation/MainHeader";
import { VerticalGapWithLine } from "src/components/styled/gaps";
import Cookies from "js-cookie";
import { CustomDialog } from "src/components/common/CustomDialog";

const MainSection = styled.div`
  display: flex;
  flex-direction: row;
`;

const Main = (props) => {
  const navigate = useNavigate();
  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    const jwtToken = Cookies.get("jwt_token");
    if (!jwtToken) {
      navigate("/login");
    }
    // console.log("Main loaded: ", jwtToken);
  }, []);
  const getBasicBusinessDetails = () => {};
  return (
    <MainSection>
      <LeftNav />
      <div style={{ width: "calc(100vw - 250px)" }}>
        <MainHeader />
        <VerticalGapWithLine />
        <Outlet></Outlet>
        <CustomDialog />
      </div>

      {/* <div>
        <div>
          <h1>Org Data</h1>
          <div
            onClick={() => {
              localStorage.removeItem("jwt_token");
            }}
          >
            Logout
          </div>
        </div>
        <div>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Working Hours" value="1" />
                <Tab label="Offerings" value="2" />
                <Tab label="Org Details" value="3" />
                <Tab label="Appointments" value="4" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <WorkingHours />
            </TabPanel>
            <TabPanel value="2">
              <OrgOfferings />
            </TabPanel>
            <TabPanel value="3">Item Three</TabPanel>
            <TabPanel value="4">
              <Appointments />
            </TabPanel>
          </TabContext>
        </div>
      </div> */}
    </MainSection>
  );
};

export { Main };
